<div class="language-list-item">
  <div class="language-list-item__header">
    <div class="language-list-item__language-avatar">
      <span>{{ language().code | languageCode }}</span>
    </div>

    <div class="language-list-item__name">
      <span class="fs__sm fw__600">{{ language().name }}</span>
      <span class="fs__sm language-code">{{ language().code }}</span>
    </div>

    <eiq-button
      [matMenuTriggerFor]="menu"
      [icon]="faEllipsisVertical"
      [color]="'light'"
      [style]="'icon'"
      [testId]="'language-list-item-' + language().code + '-menu'"
    ></eiq-button>
    <mat-menu #menu="matMenu" xPosition="before">
      <button mat-menu-item color="warn" [attr.data-testid]="'language-list-item-' + language().code + '-delete-button'" (click)="remove.emit()">
        <fa-icon [icon]="faTrashCan"></fa-icon>
        <span class="fs__sm fw__500">Delete</span>
      </button>
    </mat-menu>
  </div>

  <div class="language-list-item__status">
    <empathy-translations-status [translation]="translation()"></empathy-translations-status>
  </div>

  <div class="language-list-item__footer">
    <span class="language-list-item__last-updated fs__sm">Last Updated: {{ translation().updatedAt | date }}</span>
    <eiq-button
      [icon]="faArrowRight"
      [iconPosition]="'right'"
      [text]="translatedPercent$() === 0 ? 'Start Translation' : 'Continue'"
      [style]="'basic'"
      [testId]="'language-list-item-' + language().code + '-translate'"
      (clicked)="onTranslate()"
    ></eiq-button>
  </div>
</div>
